import { Component, h } from '@stencil/core';

@Component({
  tag: 'utrecht-icon-zweefpaal',
  styleUrl: "../../icon/generated.scss",
  shadow: true,
})
export class UtrechtIconZweefpaal {

  render() {
    return (
      <svg viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="1em" width="1em">
  <path d="M30 32v2H6v-2h6V20h12v12zM14 12h8c1.34 0 2 .9 2 2.02V18H12v-4c0-1.1.68-2 2-2"/>
</svg>

    );
  }
}
